import U2000InputText from "../../../../u2000Core/components/formControls/input/U2000InputText";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import type { TFunction } from "i18next";
import { NS } from "../../../U3148";

// Typage des props du composant
interface U3148RoleComponentProps<T extends Record<string, any>> {
  formStateHandlers: U2000FormStateHandlers<T>;
  t: TFunction;
}

// Composant principal pour la gestion des informations d'un rôle
function U3148RoleBody<T extends Record<string, any>>({ formStateHandlers, t }: U3148RoleComponentProps<T>) {
  return (
    <div className="grid grid-cols-2 gap-4">
      <U2000InputText fieldName="roleCode" label={t("role.lblRoleCode", { ns: NS })} formStateHandlers={formStateHandlers} />
      <U2000InputText fieldName="roleDescription" label={t("role.lblRoleDescription", { ns: NS })} formStateHandlers={formStateHandlers} />
    </div>
  );
}

export default U3148RoleBody;
